import {SERVICES} from '@/const/services';

const PREFIX_RECEIVE = `${SERVICES.STATIC_URL}/pubimg/`;

export const CRYPTO_CONVERT = {
  BANNER: 'bf3c1d417e63b81f848b0273f657809d90ca4c5a555b0534340ee4cfdc20501c.png',
  M_BANNER: 'c0230e3aba0c97ebbc6da0a20f8adf87f9291ab38fe2800598d693fa07a1a75a.png',
  CONVERT: 'ffbe3afaf92a89435a6c465da4ada5dc95ce1ee2384b76497013e44273a37865.png',
  CONVERT_DISABLED: '22dc33c0500f16f3e1f018056b3a8f42a709207dfc13286857d1d926d65ea294.png',
  SUCCESS: '6e3644c4a966963a5ea3adb1f2a0b56fd4f382c94483ec745d87e48254e3ffb8.png',
  FAIL: '3f2dbcdcf0fb08f72db81eafcdee223a35decf8c19ab15ed7abcec028c3346a6.png',
};

export const CRYPTO_CONVERT_NEW = {
  SUCCESS: 'https://img.phemex.com/v1/fad75539-70eb-4009-af2a-82437615dcda/frame-2087327667.png',
  FAIL: 'https://img.phemex.com/v1/3dea5d51-f6d9-4a2a-9119-385692f9db55/frame-2087327674.png',
};

Object.keys(CRYPTO_CONVERT).forEach((key) => (CRYPTO_CONVERT[key] = [PREFIX_RECEIVE, CRYPTO_CONVERT[key]].join('')));
